import type { SourcePostFilters, SerpPost } from '@/hooks/useSourcePosts';
import { serpFilterKey } from '@/hooks/serpQuery';
import { paramsToFilters } from '@/lib/serpUrl';

/**
 * WCZESNA LISTA (1.10, LCP /search). Skrypt w `index.html` (`<script data-wczesna-lista>`) wysyła
 * zapytanie o pierwszą stronę ofert zaraz po HTML-u, równolegle z JS, i zostawia obietnicę
 * w `window.__flhWczesnaLista`. Tu aplikacja ją zabiera: RAZ, przy pierwszym pytaniu o stronę 0.
 *
 * Zasady, każda z powodu:
 *  - JEDNORAZOWO, także gdy nie pasuje. Po wejściu z profilem („Moje wyszukiwanie”) albo po
 *    zmianie filtrów odpowiedź jest bezużyteczna; trzymana dłużej podałaby stare oferty przy
 *    powrocie na goły /search kilka minut później.
 *  - TYLKO DOMYŚLNE FILTRY: skrypt zna wyłącznie zapytanie gołego /search. Klucz filtrów jest
 *    ten sam, którym React Query rozróżnia listy (`serpFilterKey`).
 *  - NIE STARSZA NIŻ `MAKS_WIEK_MS`: tyle samo co `staleTime` listy, więc nic świeższego by i tak
 *    nie przyszło.
 *  - BŁĄD = ZWYKŁA ŚCIEŻKA: odrzuconą obietnicę obsługuje `fetchSerpPage`, pytając jeszcze raz.
 *
 * Zapytanie w skrypcie musi być identyczne z tym, które składa `fetchSerpPage`; pilnuje tego
 * test zgodności w `wczesnaLista.test.ts`.
 */
export const KLUCZ_WCZESNEJ_LISTY = '__flhWczesnaLista';
export const MAKS_WIEK_MS = 60_000;

export interface StronaWczesna {
  rows: SerpPost[];
  count: number | null;
}

interface WczesnaLista {
  czas: number;
  wynik: Promise<StronaWczesna>;
}

const kluczDomyslny = () => JSON.stringify(serpFilterKey(paramsToFilters(new URLSearchParams())));

export function zabierzWczesnaListe(
  filters: SourcePostFilters,
  strona: number,
  okno: Record<string, unknown> = window as unknown as Record<string, unknown>,
  teraz: number = Date.now(),
): Promise<StronaWczesna> | undefined {
  if (strona !== 0) return undefined;
  const wczesna = okno[KLUCZ_WCZESNEJ_LISTY] as WczesnaLista | undefined;
  if (!wczesna) return undefined;
  delete okno[KLUCZ_WCZESNEJ_LISTY];
  if (teraz - wczesna.czas > MAKS_WIEK_MS) return undefined;
  if (JSON.stringify(serpFilterKey(filters)) !== kluczDomyslny()) return undefined;
  return wczesna.wynik;
}
